<template>
  <Detail :businessInfo="businessInfo" />
</template>
<script>
import Detail from "../detail.vue";
import { softwareByProductApi } from "@/api/website.js";
import { prefix } from "@/utils/env";
export default {
  name: "digital-airoad",
  components: {
    Detail,
  },
  data() {
    return {
      businessInfo: {
        name: "VRRoad",
        icon: require("@/assets/images/digitalImg/vrroad_icon.png"),
        bgImg: require("@/assets/images/digitalImg/airoad_bg.png"),
        banner: {
          icon: require("@/assets/images/digitalImg/vrroad_icon.png"),
          title: "VRRoad – Being Present in Road Design Schemes",
          subTitle: "Road Driving Simulation and Safety Evaluation System",
          downloadBtnList: [
            {
              label: "Download",
              fileUrl: "",
              fileName: "VRRoad",
            },
          ],
          posterImg: require("@/assets/images/digitalImg/video_vrroad.png"),
          videoUrl: `${prefix}/static/video/VRRoad_en.mp4`,
        },
        all: {
          title: "What is VRRoad？",
          content:
            "VRRoad, a road driving, simulation and safety evaluation system, is a software and hardware integrated solution for road geometric design and safety evaluation. The system can quickly import the design results, and refer to the OpenDrive standard to generate a simulated road network that accurately describes the characteristics of the lanes and roads along the road, realizes the synchronous collection of experimental data with complete information, and supports the drive of multi-degree-of-freedom motion platforms to provide a realistic driving sense.",
          imgLists: [
            {
              id: 1,
              title: "Immersive 3D Scene（1/3）",
              img: require("@/assets/images/digitalImg/vrroad_img1.png"),
            },
            {
              id: 2,
              title: "Realistic dynamic motion sensation（2/3） ",
              img: require("@/assets/images/digitalImg/vrroad_img2.png"),
            },
            {
              id: 3,
              title: "Complete driving data（3/3）",
              img: require("@/assets/images/digitalImg/vrroad_img3.png"),
            },
          ],
        },
        highlights: {
          title: "Why Choose VRRoad？",
          lists: [
            {
              id: 1,
              icon: require("@/assets/images/digitalImg/vrroad_icon1.png"),
              title: "Integrated Design and Simulation Ecosystem",
              content:
                "Shares data with upstream design software, breaking down technical barriers between design and simulation workflows.",
            },
            {
              id: 2,
              icon: require("@/assets/images/digitalImg/vrroad_icon2.png"),
              title: "Realistic Driving Simulation Experience",
              content:
                "Uses a multi-degree-of-freedom motion platform that interacts in real-time with vehicle dynamics model data, providing a realistic dynamic driving experience.",
            },
          ],
        },
        function: {
          title: "VRRoad Functions！",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/vrroad_function01.png"),
              title: "Improve Road Design Solutions",
              content:
                "VRRoad provides comprehensive driving behavior data. Designers can analyze this data to more scientifically and accurately assess the feasibility of the design, reducing gaps and deficiencies in the design.",
            },
            {
              id: 2,
              img: require("@/assets/images/digitalImg/vrroad_function02.png"),
              title: "Enhance Safety Control Levels",
              content:
                "VRRoad offers a safe and cost-effective experimental environment for studying accident-prone sections such as long downhill stretches and continuous curves. It helps designers explore risk factors and supports the upgrade of safety control measures.",
            },
            {
              id: 3,
              img: require("@/assets/images/digitalImg/vrroad_function03.png"),
              title: "Optimize Traffic Organization",
              content: [
                "VRRoad can be applied in areas such as intersection channelization and traffic organization design for highway expansion and reconstruction during construction. It assists in scheme comparison and optimization, helping to improve the traffic capacity of bottleneck sections.",
              ],
            },
            {
              id: 4,
              img: require("@/assets/images/digitalImg/vrroad_function04.png"),
              title: "Technical Support",
              content:
                "VRRoad supports the parametric 3D model reconstruction of highways, municipal roads, bridges, tunnels, traffic safety facilities, and more, with the ability to restore design plans to a 1:1 scale. This ensures the accuracy of the simulation scene. The VRRoad development team has years of experience in driving simulation and traffic safety technologies, with a solid understanding of the details and challenges of driving simulation.",
            },
          ],
        },
        support: {
          title: "VRRoad User Support",
          documnentUrl: "/download?type=manual",
          videosUrl: "/academy?type=VRRoad",
        },
        contact: {
          bgImg: require("@/assets/images/digitalImg/vrroad_contactbg.png"),
          title: "Get VRRoad Now!",
          subTitle:
            "Delauney Digital Design Software Line provides you with a one-stop design solution.",
          firstBtnText: "Download Software",
          firstBtnUrl: "",
          secondBtnText: "Contact Sales Representative",
          secondBtnUrl: "",
        },
        combination: {
          title:
            "Enhance your workflow by integrating VRRoad with other software.",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/vrroad_combination01.png"),
              title: "When the Karakoram Highway Meets VRRoad",
              subTitle: "",
              content:
                "- The design and simulation integrated software lets you experience the charm of the Karakoram Highway in a virtual world.",
            },
          ],
          softwares: [
            {
              name: "AIRoad",
              icon: require("@/assets/images/digitalImg/airoad_icon3.png"),
              desc: "Photogrammetry, and remote sensing data. It enables dynamic interactive routing and automated scheme modeling.",
            },
          ],
        },
      },
    };
  },
  created() {
    this.getSoftware();
  },
  methods: {
    async getSoftware() {
      await softwareByProductApi({ productId: "3" }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          if (res.data.length > 0 && res.data[0].pathUrlIdList.length > 0) {
            this.businessInfo.banner.downloadBtnList[0].fileUrl =
              res.data[0].pathUrlIdList[0].path;
            this.businessInfo.banner.downloadBtnList[0].fileName =
              res.data[0].pathUrlIdList[0].fileTitle;
          } else {
            this.businessInfo.banner.downloadBtnList[0].fileUrl = "";
            this.businessInfo.banner.downloadBtnList[0].fileName = "";
          }
        }
      });
    },
  },
};
</script>
